export default __webpack_public_path__ + "static/media/020-mace.779b10e1.svg";